export default {plugin:{connector:{ui:{connect:'连接到 {{ auth_name }}',remove:'解绑 {{ auth_name }}'}}}};